module.exports = __webpack_public_path__ + "fonts/semibold.641c0ff.woff";